import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/i18n";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const { t } = useLang();
  const a = t.admin;
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur de connexion");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#0A1A2F] via-[#0d2138] to-[#0A1A2F]" />
      <Link to="/" className="absolute top-6 left-6 text-muted-foreground hover:text-white flex items-center gap-2 text-sm z-10" data-testid="back-home">
        <ArrowLeft className="w-4 h-4" /> Accueil
      </Link>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        className="relative z-10 w-full max-w-sm glow-border glass rounded-2xl p-8 accent-glow" data-testid="admin-login">
        <div className="flex justify-center mb-6"><Logo size={32} /></div>
        <div className="flex items-center justify-center gap-2 mb-1">
          <Lock className="w-4 h-4 text-accent" strokeWidth={1.5} />
          <h1 className="font-display text-xl font-bold">{a.space}</h1>
        </div>
        <p className="text-center text-sm text-muted-foreground mb-6">Olivier Toussaint · I-LEASE SRL</p>
        <form onSubmit={submit} className="space-y-4">
          <Input type="email" placeholder={a.email} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="bg-white/5 border-white/10 focus-visible:ring-accent" />
          <Input type="password" placeholder={a.password} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="bg-white/5 border-white/10 focus-visible:ring-accent" />
          <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full rounded-full bg-accent hover:bg-accent/90 text-white h-11 font-medium">
            {loading ? a.signingin : a.signin}
          </Button>
        </form>
      </motion.div>
    </div>
  );
}
